import { type HTMLAttributes } from "react";

type AlertVariant = "info" | "success" | "warning" | "error";

export interface AlertProps extends HTMLAttributes<HTMLDivElement> {
  variant?: AlertVariant;
}

const variantClasses: Record<AlertVariant, string> = {
  info: "bg-[var(--color-accent-muted)] border-[var(--color-accent)] text-[var(--color-text)]",
  success: "bg-emerald-950/50 border-emerald-800 text-emerald-300",
  warning: "bg-amber-950/50 border-amber-700 text-amber-300",
  error: "bg-red-950/50 border-red-800 text-red-300",
};

export function Alert({
  variant = "info",
  className = "",
  ...props
}: AlertProps) {
  return (
    <div
      role="alert"
      className={
        "rounded-[var(--radius-md)] border p-4 " +
        variantClasses[variant] +
        (className ? " " + className : "")
      }
      {...props}
    />
  );
}
